import React from 'react';
import PropTypes from 'prop-types';
import {Auth0Provider} from '@auth0/auth0-react';
import Config from 'hooks/config';
import {ROUTES} from 'constants/app-routes';

import AuthAPISetupProvider from 'common/auth/AuthAPISetupProvider';

const AuthProviderWithHistory = ({history, children}) => {
    const onRedirectCallback = (appState) => {
        // Use the router's history module to replace the url
        history.replace(appState?.returnTo || window.location.pathname);
    };

    const redirectUri = `${window.location.origin}${Config.basename}${ROUTES.dashboard}`;

    return (
        <Auth0Provider
            domain={Config.auth0Domain}
            clientId={Config.auth0ClientId}
            redirectUri={redirectUri}
            audience={Config.auth0V1APIAudience}
            onRedirectCallback={onRedirectCallback}
        >
            <AuthAPISetupProvider>{children}</AuthAPISetupProvider>
        </Auth0Provider>
    );
};

AuthProviderWithHistory.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object,
};

export default AuthProviderWithHistory;
